import styled from 'styled-components'
import Plus from 'svg/plus-rounded-corners.svg'

export const PlusIcon = styled(Plus)`
  width: 20px;
  height: 20px;
  fill: #333;
  margin-top: 5px;
  &:hover {
    fill: ${(props) => props.theme.colors.blue};
  }
`
